import Iphone from './Iphone';
import { width } from '../shared/width-informer';
import $ from 'jquery';
import 'jquery.cookie';

export default class Dots {
  constructor(selector, dotSelector) {
    this.preloader = document.querySelector(selector);
    this.dots = this.preloader
      ? this.preloader.querySelectorAll(dotSelector)
      : '';
    this.Iphone = new Iphone('.js-iphone');
    this.lang = $('html').attr('lang');
  }

  init() {
    if (!this.check()) {
      return;
    }

    if (width() < 1024) {
      this.Iphone.init();
      return;
    }

    const self = this;

    if ($.cookie(`jhd;sjdj${self.lang}`)) {
      $(() => {
        setTimeout(() => {
          self.Iphone.init();
          self.Iphone.play();
        }, 500);
      });
    } else {
      $(() => {
        setTimeout(() => {
          self.preloader.style.display = 'block';
          self.main();
        }, 500);
      });
    }
  }

  main() {
    const self = this;

    const tl = new TimelineMax({
      onComplete,
      repeat: 2
    });

    tl.staggerFromTo(
      this.dots,
      0.6,
      { autoAlpha: 0.1, scale: 0.2, ease: Power0.easeNone },
      { autoAlpha: 1, scale: 1, ease: Power0.easeNone },
      0.4
    );

    function onComplete() {
      tlFinish.play();
    }

    function showPhones() {
      self.Iphone.init();
      self.Iphone.play();
    }

    const tlFinish = new TimelineMax({
      paused: true,
      onComplete: showPhones
    });

    tlFinish.staggerTo(
      this.dots,
      0.4,
      { autoAlpha: 0, scale: 0.5, ease: Power0.easeNone },
      0.1
    );
  }

  check() {
    if (!this.preloader) return false;

    return true;
  }
}

const dots = new Dots('.js-preloader', '.js-dot');

dots.init();
